// extracted by mini-css-extract-plugin
module.exports = {"claimsView":"claimsView--2uNOr","claimsTitle":"claimsTitle--Wv6jM","claimsSeparator":"claimsSeparator--1ffAZ","claimsMainBox":"claimsMainBox--3dcLb"};